import { Icon } from 'assets/index'
import Div from './style'

interface IShowDetailsProps {
  hidden?: boolean
  onClick?: any
}

export default function ShowDetails(props: IShowDetailsProps) {
  const { hidden } = props

  return (
    <Div {...props}>
      <img
        className="showDetails-img"
        src={!hidden ? Icon('chevron_up.svg') : Icon('chevron_down.svg')}
        alt="card icon"
      />
      <span className="showDetails-span">Detalhes do cliente</span>
    </Div>
  )
}
